import Services from "@/components/Services";
import Process from "@/components/Process";
import CtaBand from "@/components/CtaBand";

export default function ServicesPage() {
  return (
    <main data-testid="page-services" className="pt-[72px]">
      <Services />
      <Process />
      <CtaBand />
    </main>
  );
}
